import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaConfiguracionDocumentosComponent {
  archivo = undefined
  empresaId = null
  documentoId = null
  guardar = false
  type = 'image/jpeg'
  url = null

  constructor ($api, $window, $fileSystem, EmpresaConfiguracionDocumentos) {
    this.$api = $api
    this.$window = $window
    this.$fileSystem = $fileSystem
    this.EmpresaConfiguracionDocumentosService = EmpresaConfiguracionDocumentos
  }

  $onInit () {
    this.promise = this.EmpresaConfiguracionDocumentosService.get(this.empresaId)
      .then((response) => (this.data = response.data))
  }

  descargar (item) {
    if (!item) return

    this.url = this.$api.link('/api/empresa/configuracion/documento', {
      empresa_id: this.empresaId,
      documento_id: item.documento_id,
      version: item.version,
    })

    this.$window.open(this.url, item.nombre)
  }

  seleccionar (item) {
    this.$fileSystem.select(false, this.type)
      .then((files) => {
        this.archivo = files[0]
        this.documentoId = item.documento_id
        this.guardar = true
      })
  }

  confirmacion (data) {
    this.guardar = false
    if (data.exito) {
      this.data.documentos = this.data.documentos.filter((item) => {
        if (item.documento_id === this.documentoId) {
          item.nombre = this.archivo.name
          item.version = data.version
        }
        return item
      })
    }
    this.archivo = undefined
    this.documentoId = undefined
  }
}


module.component('empresaConfiguracionDocumentos', {
  controller: EmpresaConfiguracionDocumentosComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/configuracion/documentos/component.js